const SymphonyXTSSection = () => {
  return (
    <section className="about about--style1 bg-color xts-section">
      <div className="container">
        <div className="about__wrapper">
          <div className="row gx-5 gy-4 gy-sm-0 align-items-center">
            {/* Investment Strategy */}
            <div className="col-lg-12 mt-30">
              <div className="about__content">
                <div
                  className="about__content-inner"
                  data-aos="fade-right"
                  data-aos-duration="500"
                >
                  <h3 className="section-title mb-3">Rest Based API XTS</h3>
                  <p>
                    A robust popular platform for Algo Trading with Indian
                    Exchanges
                  </p>
                  <p className="mb-4">
                    XTS API is a comprehensive platform to Design, Test, Deploy,
                    Execute and Monitor fully automated trading or execution
                    algos using asset classes available in Indian Exchanges.
                    Presto provides a framework to deploy the algos with Live
                    Market Data and Direct Market Access (DMA).
                  </p>

                  <h6>The XTS platform can be operated in three modes:</h6>
                  <ul>
                    <li>
                      <i className="fas fa-check-circle"></i> Live Trading
                    </li>
                    <li>
                      <i className="fas fa-check-circle"></i> Paper Trading
                    </li>
                  </ul>

                  <h6>Main Features of XTS API</h6>
                  <ul>
                    <li>
                      <i className="fas fa-check-circle"></i> Customizable
                      Platform
                    </li>
                    <li>
                      <i className="fas fa-check-circle"></i> Run hundreds of
                      algos developed with Presto Studio
                    </li>
                    <li>
                      <i className="fas fa-check-circle"></i> Interact with
                      multiple markets and data vendors simultaneously
                    </li>
                    <li>
                      <i className="fas fa-check-circle"></i> Transparent APIs
                      (Application Program Interfaces) / Presto Studio to
                      develop own Algo Strategies
                    </li>
                    <li>
                      <i className="fas fa-check-circle"></i> Inbuilt RMS
                      enabled for Exchange/SEBI compliance
                    </li>
                    <li>
                      <i className="fas fa-check-circle"></i> FIX enabled
                    </li>{" "}
                    <li>
                      <i className="fas fa-check-circle"></i> Approved by
                      Multiple Exchanges
                    </li>{" "}
                    <li>
                      <i className="fas fa-check-circle"></i> Excel/TradeStation
                      /Amibroker connectivity
                    </li>
                    <li>
                      <i className="fas fa-check-circle"></i> Direct market
                      access provided for NSE/BSE
                    </li>
                  </ul>

                  {/* <h6>List of Approved Strategies</h6>
                  <ul>
                    <li>
                      <i className="fas fa-check-circle"></i> Presto Jobex
                      strategy Write up version 1.2
                    </li>
                    <li>
                      <i className="fas fa-check-circle"></i> Presto
                      opportunistic Target completion (OTC) strategy Write up
                      version 2.1
                    </li>
                    <li>
                      <i className="fas fa-check-circle"></i> Presto call smart
                      Executor Strategy
                    </li>

                    <li>
                      <i className="fas fa-check-circle"></i> Presto Smart
                      Executor Strategy Write up version 1.1
                    </li>
                    <li>
                      <i className="fas fa-check-circle"></i> Presto Smart
                      Jobbing Strategy Version 2.1
                    </li>

                    <li>
                      <i className="fas fa-check-circle"></i> Presto Smart Swing
                      Strategy Write up Version 1.1
                    </li>
                  </ul> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SymphonyXTSSection;
